import Module from "./Module";
import { filter } from "lodash";
import { Link } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import useApp from "hooks/useApp";
import useAuth from "hooks/useAuth";
import { useTranslation } from 'react-i18next';
export default function Modules(props) {
  const { onCardClick } = props;
  const app = useApp();
  const auth = useAuth();
  const { t } = useTranslation();
  const MODULE=t("MODULE");
  const VIEW_MORE=t("VIEW_MORE");
  const NO_MODULES_FOUND=t("NO_MODULES_FOUND");
  const { modules: modulesData, modulesInProgress } = app;
  let modules = modulesData;
  if (["Admin", "User"].includes(auth?.user?.roleName)) {
    modules = filter(
      modulesData,
      (item) => auth?.user?.modules_ids.includes(item.id),
      []
    )
  }
  return (
    <main id="modules" className="main-page">
      <section className="page-section q-pa-md">
        <div className="container-fluid">
          <div className="grid">
            <div className="col comp-grid">
              <h5>{MODULE}</h5>
            </div>
            {modules.length > 4 && (
              <div className="col comp-grid" style={{ textAlign: "end", color: "var(--primary-color)" }}>
                <Link to="/complete_modules">{VIEW_MORE}</Link>
              </div>
            )}
          </div>

          {modulesInProgress ? (
            <ProgressSpinner
              style={{ position: "absolute", top: "35%", left: "40%" }}
            />
          ) : modules.length > 0 ? (
            <div className="w-full rounded h-full flex gap-3 flex-wrap">
              {modules.slice(0, 6).map((module) => {
                const {
                  id,
                  code,
                  icon,
                  module_name,
                  patient_count,
                  percentage,
                  color,
                } = module;
                return (
                  <Module
                    key={id}
                    icon={icon}
                    title={module_name}
                    patient_count={patient_count}
                    percentage={percentage}
                    bgColor={color}
                    onClick={onCardClick}
                    moduleId={id}
                  />
                );
              })}
            </div>
          ) : (
            <div
              style={{
                height: "350px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span className="text-xl text-400 font-bold">
                {NO_MODULES_FOUND}
              </span>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
